export default "__VITE_ASSET__BL2u5lgT__"